@if (iconName) {
  <span class="icon material-symbols-rounded">
    {{ iconName }}
  </span>
}

@if (title) {
  <p class="title">
    {{ title }}
  </p>
}
